import React from 'react';

// Editor de plantillas de recibo (TAL-1): solo el administrador
export const PlantillasReciboConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['admin'],
    routes: [{
        path: '/plantillas-recibo',
        component: React.lazy(() =>
            import ('./PlantillasRecibo'))
    }]
};
